// @ts-check
import * as React from "react";
import firebase from "firebase/app";
import "firebase/auth";
import { useDispatch, useSelector } from 'react-redux';
import { SET_NOT_SIGNED_IN, SET_SIGNED_IN } from '../../redux/actions/actionTypes'
import {
  FirebaseAuthProvider,
  FirebaseAuthConsumer
} from "@react-firebase/auth";


const config = {
  apiKey: "AIzaSyBCEvhqNru2YMS4T79v3RiiQeyruR8NCVw",
  authDomain: "iamplooto.firebaseapp.com",
  databaseURL: "https://iamplooto.firebaseio.com",
  projectId: "iamplooto",
  storageBucket: "iamplooto.appspot.com",
  messagingSenderId: "793065362684",
  appId: "1:793065362684:web:3dd3ab8dbdbf3b0320f379",
  measurementId: "G-PLQ2CXY4T4"
}

let timer

const FirebaseAuth = () => {
  const dispatch = useDispatch()

  return (
    <div>
      <FirebaseAuthProvider {...config} firebase={firebase}>
        <FirebaseAuthConsumer>
          {({ isSignedIn, user, providerId }) => {
            if (isSignedIn === true) {
              clearTimeout(timer)

              dispatch({
                type: SET_SIGNED_IN,
                payload: {
                  user,
                  providerId
                }
              })

              console.log('signed in')
              console.log('user id:', user.uid)
            } else {
              // the delay is here to give firebase a chance to set isSignerIn to true and clear the timer
              timer = setTimeout(() => {
                dispatch({
                  type: SET_NOT_SIGNED_IN,
                  payload: {
                    user: null,
                    providerId
                  }
                })

                firebase.auth().signInAnonymously().then(() => {
                  console.log('new sign in!')
                })
                // see if we need the logic below
              }, 2000)
              
            }
          }}
        </FirebaseAuthConsumer>
      </FirebaseAuthProvider>
    </div>
  );
};

export default FirebaseAuth


// plooto.promptUserData = (userId) => {
//   const name = prompt('Please let us know your name')
//   const sector = prompt('Please let us know your sector')
//   return {
//     name,
//     sector
//   }
// }

// plooto.signIn = async (userId) => {
//   const currUser = localStorage.userData ? JSON.parse(localStorage.userData) : {}
//   if (currUser.id === userId.split(' ')[1]) { // known user - data from localStorage
//     return
//   }

//   const existingUser = await plooto.serverSignIn(userId)
//   if (existingUser) { // known user - data from server
//     localStorage.userData = JSON.stringify(existingUser)
//     return
//   }

//   // new user
//   const userData = plooto.promptUserData(userId)
//   const user = await plooto.createUser(userId, userData)
//   localStorage.userData = JSON.stringify(user)
// }